//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
let d=[[[0,"LabelPMI",1,0],[0,"Name",1,0],[0,"NaturalFrequenciesCount",0,0],[0,"NaturalFrequencyIndex",1,0],[0,"ResultComponent",1,0],[0,"ResultType",1,0],[0,"ResultValue",1,0],[1,"SelectedEntities",0,"ScCollector",0],[0,"UserSetName",1,0]],[],[]];
SPLM.DesignSimulation.ResultMeasureBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.ResultMeasureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DesignSimulation.ResultMeasureBuilder.ResultTypeOption = Object.freeze({
    "Displacement" : "Displacement", "Stress" : "Stress", "SafetyFactor" : "SafetyFactor", "Thermal" : "Thermal"});

SPLM.DesignSimulation.ResultMeasureBuilder.ResultComponentOption = Object.freeze({
    "DisplacementMagnitude" : "DisplacementMagnitude", "DisplacementWorstInXYZ" : "DisplacementWorstInXYZ", "DisplacementX" : "DisplacementX", "DisplacementY" : "DisplacementY", "DisplacementZ" : "DisplacementZ", "StressVonMises" : "StressVonMises", "StressWorstPrincipal" : "StressWorstPrincipal", "SafetyFactorVonMises" : "SafetyFactorVonMises", "Temperature" : "Temperature", "StressVoigtSigmaXX" : "StressVoigtSigmaXX", "StressVoigtSigmaYY" : "StressVoigtSigmaYY", "StressVoigtSigmaZZ" : "StressVoigtSigmaZZ", "StressVoigtSigmaXY" : "StressVoigtSigmaXY", "StressVoigtSigmaYZ" : "StressVoigtSigmaYZ", "StressVoigtSigmaZX" : "StressVoigtSigmaZX"});

SPLM.DesignSimulation.ResultMeasureBuilder.ResultValueOption = Object.freeze({
    "Minimum" : "Minimum", "Maximum" : "Maximum"});

export default SPLM;